import getConstants from '../../util/constants';
import { SupportPhoneNumber } from './SupportPhoneNumber';

const { CONTACT_US_PHONE_NUMBER } = getConstants();

type WithPhoneNumberProps = {
  text: string | undefined;
};

export const WithPhoneNumber = ({ text }: WithPhoneNumberProps) => {
  const parts = text?.split(CONTACT_US_PHONE_NUMBER);

  if (!parts || parts.length <= 1) {
    return <>{text}</>;
  }

  return (
    <>
      {parts.map((part, index) => (
        <>
          {part}
          {index < parts.length - 1 && <SupportPhoneNumber />}
        </>
      ))}
    </>
  );
};
